const getIsVisible = (el) => {
  const { top, bottom } = el.getBoundingClientRect();
  const windowH = window.innerHeight;
  return (
    (top > 0 && top < windowH)
    || (bottom > 0 && bottom < windowH)
  );
};

export default {
  inserted(el, binding) {
    const onViewportChange = () => {
      if (getIsVisible(el)) {
        el.classList.add(binding.value);
        window.removeEventListener('scroll', onViewportChange);
        window.removeEventListener('resize', onViewportChange);
      }
    };
    window.addEventListener('scroll', onViewportChange);
    window.addEventListener('resize', onViewportChange);
    onViewportChange();
  },
};
// how to use
